function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.15 0.15)"
}, /*#__PURE__*/React.createElement("path", {
  className: "route",
  d: "M4.942,15.448a1.564,1.564,0,1,0,2.271,1.868h4.054a1.565,1.565,0,1,1,0,3.129H5.007a2.608,2.608,0,0,0,0,5.216h5.216a.522.522,0,1,0,0-1.043H5.007a1.565,1.565,0,1,1,0-3.129h6.259a2.608,2.608,0,1,0,0-5.216H7.212a1.573,1.573,0,0,0-.679-.825l3.984-6.536a5.737,5.737,0,1,0-9.559,0Zm.8,1.868a.522.522,0,1,1,.522-.522A.522.522,0,0,1,5.737,17.316Zm0-16.273a4.695,4.695,0,0,1,3.906,7.3l-.012.018L5.737,14.749,1.831,8.342a4.695,4.695,0,0,1,3.906-7.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "route",
  d: "M62.608,65.216A2.608,2.608,0,1,0,60,62.608,2.611,2.611,0,0,0,62.608,65.216Zm0-4.173a1.565,1.565,0,1,1-1.565,1.565A1.566,1.566,0,0,1,62.608,61.043Z",
  transform: "translate(-56.871 -56.871)"
}), /*#__PURE__*/React.createElement("path", {
  className: "route",
  d: "M282.572,166a5.738,5.738,0,0,0-4.776,8.916l3.969,6.225a1.573,1.573,0,0,0-.667.818h-4.575a.522.522,0,0,0,0,1.043H281.1a1.565,1.565,0,1,0,2.283-1.861l3.969-6.225A5.738,5.738,0,0,0,282.572,166Zm0,17a.522.522,0,1,1,.522-.522A.522.522,0,0,1,282.572,183Zm3.906-8.661-3.906,6.126-3.906-6.126a4.694,4.694,0,1,1,7.812,0Z",
  transform: "translate(-261.605 -157.342)"
}), /*#__PURE__*/React.createElement("path", {
  className: "route",
  d: "M354.608,226a2.608,2.608,0,1,0,2.608,2.608A2.611,2.611,0,0,0,354.608,226Zm0,4.173a1.565,1.565,0,1,1,1.565-1.565A1.566,1.566,0,0,1,354.608,230.173Z",
  transform: "translate(-333.641 -214.213)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "route",
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  transform: "translate(11.966 24.685)"
}));

var SvgRoutes = function SvgRoutes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.004,
    height: 40.004,
    viewBox: "0 0 27.004 30.004",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoutes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/routes.9fae231e.svg";
export { ForwardRef as ReactComponent };